import $ from 'jquery';
import matchHeight from 'jquery-match-height';

$(window).on('load', function () {
	$('.js-matchHeightevent').matchHeight();
});
